import { render, staticRenderFns } from "./SearchBtn.vue?vue&type=template&id=ce1c1584&scoped=true&"
import script from "./SearchBtn.vue?vue&type=script&lang=js&"
export * from "./SearchBtn.vue?vue&type=script&lang=js&"
import style0 from "./SearchBtn.vue?vue&type=style&index=0&id=ce1c1584&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1c1584",
  null
  
)

export default component.exports